import { readCookie } from '../cookies';
export const AUTOCAR = 'autocar';

const lastPostCode = readCookie('lastPostCode') || '';
// Autocar
export const AUTOCARUTMLINKS = [
  'utm_source=haymarket_autocar',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARLEASINGUTMLINKS = [
  'utm_source=haymarket_autocar_leasing',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARNEWCARUTMLINKS = [
  'utm_source=haymarket_autocar_newcar',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARNEWCARSTOCKCAROUSELLINKS = [
  'utm_source=HM_AC_SD_popular_cars',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARNEWCARSTOCKSQUICKLOOKLINKS = [
  'utm_source=HM_AC_SD_quick_look_popup',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARNEWCARSTOCKSRESULTSLINKS = [
  'utm_source=HM_AC_SD_stock_car_results',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARCARLEASINGCAROUSELLINKS = [
  'utm_source=HM_AC_Leasing_popular_cars',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARCARLEASINGDEALSLINKS = [
  'utm_source=HM_AC_Leasing_leasing_results',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARUSEDCARSCAROUSELLINKS = [
  'utm_source=HM_AC_UCD_popular_cars',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARUSEDCARSQUICKLOOKLINKS = [
  'utm_source=HM_AC_UCD_quick_look_popup',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const AUTOCARUSEDCARSTOCKSRESULTSLINKS = [
  'utm_source=HM_AC_UCD_classifieds_results',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

// WhatCar?
export const WHATCARUTMLINKS = [
  'utm_source=haymarket_whatcar',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const WHATCARLEASINGUTMLINKS = [
  'utm_source=haymarket_whatcar_leasing',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const WHATCARNEWCARUTMLINKS = [
  'utm_source=haymarket_whatcar_newcar',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const NEWCARSTOCKCAROUSELLINKS = [
  'utm_source=HM_WC_SD_popular_cars',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const NEWCARSTOCKSQUICKLOOKLINKS = [
  'utm_source=HM_WC_SD_quick_look_popup',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const NEWCARSTOCKSRESULTSLINKS = [
  'utm_source=HM_WC_SD_stock_car_results',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const CARLEASINGCAROUSELLINKS = [
  'utm_source=HM_WC_Leasing_popular_cars',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const CARLEASINGDEALSLINKS = [
  'utm_source=HM_WC_Leasing_leasing_results',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const USEDCARSCAROUSELLINKS = [
  'utm_source=HM_WC_UCD_popular_cars',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const USEDCARSQUICKLOOKLINKS = [
  'utm_source=HM_WC_UCD_quick_look_popup',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];

export const USEDCARSTOCKSRESULTSLINKS = [
  'utm_source=HM_WC_UCD_classifieds_results',
  'utm_medium=partnership',
  `postcode=${lastPostCode}`
];



// WEBPACK FOOTER //
// ./src/utils/utmLinks/utm.links.js